// extracted by mini-css-extract-plugin
export var button = "_c7-2";
export var iconWrapper = "_c7-0";
export var investigatingIcon = "_c7-1";